<script>
	import { fly } 		  from 'svelte/transition';
	import Container      from './Container.svelte';
	import Gallery        from './Gallery.svelte';
	import Icon           from './General/Icon.svelte';
	import Button         from './General/Button.svelte';
	import ProductContent from './ProductContent.svelte';
	import ContactForm    from './ContactForm.svelte';
	import Socials 		  from './Socials.svelte';
	import { translate }  from '../lib/translate';
	import { style, useContactForm, appRoute } from '../lib/store';

	export let data = {};

	console.log(data)

	data.hdVideo = data.hdVideo || [];
	data.photo360 = data.photo360 || [];

	$: product = data ? {
		title    : data.title,
		subTitle : data.typeExtraInformation,
		location : data.city,
		price    : data.internetPrice,
		specs    : [
			data.summary?.slice(0, 3).map(({ value, unit }) => value + (unit ?? '')),
			data.summary?.slice(3).map(({ value, unit }) => value + (unit ?? '')),
		],
		refNo    : data.truckId,
		trail    : [data.vehicleTypeName, data.brand, data.title],
		hdVideo  : data.hdVideo,
		photo360 : data.photo360,
		allMedia : data ? [
			...data.images?.map(image => ({
				src: image,
				type: 'image',
			})),
			...(data.hdVideo?.map(video => ({
				src: video,
				type: 'video',
			}))),
			...data.photo360?.map(frame => ({
				src: frame,
				type: '360',
			})),
		] : [],
	}: {};

	let contactVisible = false;

	function showContact() {
		contactVisible = true;
	}

	function hideContact() {
		contactVisible = false;
	}
</script>

<header>
	<!-- @TODO find a better way to use breakpoints inline -->
	<div transition:fly={{ y: -20 }} class="show-for-large">
		<div class="overlay">
			<Container flex right>
				<ProductContent {...product} light />
			</Container>
			<div class="cta">
				<Container flex right>
					<div class="content small">
						<div class="price">
							{new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' }).format(product.price).replace(',00', '')}
						</div>
						<div class="cta-buttons">
							<span>
								{#if useContactForm}
									<Button
										icon="ARROW_RIGHT"
										action={() => contactVisible = true}
										text={translate('Kontakt aufnehmen')}
										lightMode={style === 'WBS'}
									/>
								{:else}
									<Button
										icon="ARROW_RIGHT"
										href={"//basworld.com/ref/" + data.truckId}
										text={translate('Kontakt aufnehmen')}
										lightMode={style === 'WBS'}
									/>
								{/if}
							</span>
						</div>
					</div>
				</Container>
			</div>
		</div>
		<Container>
			<div class="navigation {style}">
				<a href={"/" + appRoute}>
					<div class="icon">
						<Icon
							name="ARROW_RIGHT"
							size={14}
							rotate={180}
							color="white"
						/>
					</div>
					<span>{translate('back_to_results')}</span>
				</a>
				<span class="divider">|</span>
				<div class="bread-crumbs">
					{#each product.trail as crumb}
						<div class="crumb">
							{translate(crumb)}
						</div>
					{/each}
				</div>
				<Socials title={product.title} />
			</div>
			<div class="gallery">
				<Gallery columns={5} maxThumbs={5} media={product.allMedia} />
			</div>
		</Container>
	</div>

	<div class="hide-for-large">
		<div class="overlay"></div>
		<Container>
			<div class="navigation">
				<a href={"/" + appRoute}>
					<div class="icon">
						<Icon
							name="ARROW_RIGHT"
							size={14}
							rotate={180}
							color="white"
						/>
					</div>
					<span>{translate('back_to_results')}</span>
				</a>
				<span class="divider">|</span>
				<div class="bread-crumbs">
					{#each product.trail as crumb}
						<div class="crumb">
							{crumb}
						</div>
					{/each}
				</div>
				<Socials />
			</div>
		</Container>
		<Container>
			<div class="gallery">
				<Gallery columns={5} maxThumbs={5} media={product.allMedia} />
			</div>
		</Container>
		<Container>
			<ProductContent {...product} />
			<div class="cta">
				<div class="content small">
					<div class="price">
						{new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' }).format(product.price).replace(',00', '')}
					</div>
					<div class="cta-buttons">
						<span>
							{#if useContactForm}
								<Button
									icon="ARROW_RIGHT"
									action={showContact}
									text={translate('Kontakt aufnehmen')}
									visible={contactVisible}
									hide={hideContact}
									lightMode={style === 'WBS'}
								/>
							{:else}
								<Button
									icon="ARROW_RIGHT"
									href={"//basworld.com/ref/" + data.truckId}
									text={translate('Kontakt aufnehmen')}
									lightMode={style === 'WBS'}
								/>
							{/if}
						</span>
					</div>
				</div>
			</div>
		</Container>
	</div>
	<ContactForm
		visible={contactVisible}
		hide={hideContact}
		show={showContact}
		vehicle={{
		name: product.title,
		image: product.allMedia[0]?.src || '',
		refNo: product.refNo,
		}}
	/>
</header>

<style lang="scss">
	@import '../scss/mixins.scss';

	header {
		page-break-after: always;
		.overlay {
			width: 100%;
			position: absolute;
			top: 0;
			left: 0;
			padding-top: 300px;
			background-color: var(--c-primary);
			color: white;

			@media (max-width: 899px) {
				padding-top: 450px;
			}
		}
	}

	.navigation {
		padding-top: 162px;
		padding-bottom: 80px;
		color: white;
		display: flex;
		align-items: center;
		position: relative;
		z-index: 1;

		@media (max-width: 840px) {
			padding-top: 107px;
		}

		@media (max-width: 760px) {
			flex-direction: column;
			align-items: flex-start;
			justify-content: center;
		}

		a:first-child {
			display: flex;

			.icon {
				transition: left .2s ease-in-out;
				position: relative;
				left: 0px;
			}

			&:hover .icon {
				left: -10px
			}
		}

		span:not(.divider) {
			margin-left: 21px;
			font-weight: 600;
			color: white;
		}

		.divider {
			width: 75px;
			text-align: center;
			line-height: 29px;
			font-size: 19px;

			@media (max-width: 760px) {
				display: none;
			}
		}

		.bread-crumbs {
			display: flex;
			flex: 1;

			@media (max-width: 760px) {
				margin-top: 20px;
				margin-bottom: 20px;
				display: block;

				.crumb {
					display: inline-block;
				}
			}

			.crumb {
				&:not(:last-child)::after {
					content: ">";
					width: 40px;
					display: inline-block;
					text-align: center;
				}
			}
		}
	}

	.gallery {
		width: calc(100% - 436px);
		@media (max-width: 899px) {
			width: 100%;
		}
	}

	.cta {
		width: 100%;
		position: static;
		top: 100%;
		margin-top: 20px;

		@include tablet-landscape {
			position: absolute;
		}

		.content {
			width: 238px;
			margin-right: 92px;

			@include small-only {
				width: 100%;
				margin-right: 46px;
			}
		}

		.price {
			display: flex;
			align-items: flex-end;
			flex-grow: 1;
			color: var(--c-sky-blue);
			line-height: 55px;
			font-weight: 700;
			font-size: 36px;
			margin-bottom: 30px;
		}
	}

	.hide-for-large .socials {
		position: relative;
		top: 20px;
	}

	.cta-buttons {
		span {
			margin-bottom: 8px;
			display: flex;
			flex-direction: column;
			gap: 10px;
		}
	}

	@media print {
		.navigation,
		.cta-buttons,
		:global(
			body footer,
			button,
			#qlwapp,
			.thumb-overlay,
			.header-wrap,
			text,
		) {
			display: none !important;
		}

		:global(.gallery .image img) {
			height: 700px;
		}
	}

	// Style overrides
	.navigation.WBS{
		padding-top: 80px;
		a {
			text-decoration: none;
		}
	}
</style>
